 export const colors = [
  {primary: '#6D8752'},
  {primary: '#70AB32'},
  {primary: '#30443C'},
]
